import { createReducer } from 'redux-create-reducer'
import * as actionTypes from '../constants/chatActionTypes'

const initialState = {
	byIds: {
		bot: {
			id: 'bot',
			name: 'Zain Bot',
			avatarUrl:
				'https://botbuilder.labiba.ai/maker/files/2c679b3b-60f5-4ab9-9b84-9d9ee9e6dc80.jpg',
		},
	},
	ownId: null,
	currentAgent: 'bot',
}

export default createReducer(initialState, {
	[actionTypes.NEW_USER](state, action) {
		return {
			...state,
			currentAgent: action.payload.id,
			byIds: {
				...state.byIds,
				[action.payload.id]: action.payload,
			},
		}
	},
	[actionTypes.OWN_DATA_RECEIVED](state, action) {
		return {
			...state,
			ownId: action.payload.id,
			byIds: {
				...state.byIds,
				[action.payload.id]: {
					...action.payload,
					name: 'Client',
				},
			},
		}
	},
	[actionTypes.CHAT_ENDED](state, action) {
		return {
			...state,
			currentAgent: initialState.currentAgent,
		}
	}
})

export const getUsers = state => state.users.byIds
export const getOwnId = state => state.users.ownId
export const getCurrentAgent = state => state.users.byIds[state.users.currentAgent]



// WEBPACK FOOTER //
// ./src/reducers/users.js